const wearos = "https://wear-os.onrender.com"
const socket_wearos = 'wss://wear-os.onrender.com'
const local_test = "https://github-cloud-run-service-ojw7p263za-ey.a.run.app"

const API = {
    wearos,
    socket_wearos,
    local_test
}

export default API